interface Props {
  color?: string
  width?: number
  height?: number
}

export const BorderIcon = ({ color = '#6F6F6F', width = 22, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.75 0.5H2.25C1.2835 0.5 0.5 1.2835 0.5 2.25V19.75C0.5 20.7165 1.2835 21.5 2.25 21.5H19.75C20.7165 21.5 21.5 20.7165 21.5 19.75V2.25C21.5 1.2835 20.7165 0.5 19.75 0.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
